import { useEffect, useCallback } from "react";
import { MonitoringService } from "../services/MonitoringService";
import { AnalyticsService } from "../services/AnalyticsService";
import { PerformanceMonitor } from "../services/PerformanceMonitor";
import { useAuth } from "./useAuth";

export const useMonitoring = () => {
  const { user } = useAuth();
  const monitoring = MonitoringService.getInstance();
  const analytics = AnalyticsService.getInstance();
  const performance = PerformanceMonitor.getInstance();

  useEffect(() => {
    if (user) {
      analytics.startSession(user.id);

      // Track page views
      const trackPageView = () => {
        analytics.trackEvent(user.id, "page_view", {
          page: window.location.pathname,
          referrer: document.referrer,
        });
      };

      trackPageView();
      window.addEventListener("popstate", trackPageView);

      // Monitor performance
      const performanceInterval = setInterval(() => {
        const metrics = performance.getMetrics();
        monitoring.recordMetric("app_performance", metrics.responseTime, {
          userId: user.id,
        });
      }, 60000);

      return () => {
        analytics.endSession(user.id);
        window.removeEventListener("popstate", trackPageView);
        clearInterval(performanceInterval);
      };
    }
  }, [user]);

  const logEvent = useCallback(
    (event: string, data: Record<string, any> = {}) => {
      if (user) {
        analytics.trackEvent(user.id, event, data);
      }
    },
    [user, analytics]
  );

  const logError = useCallback(
    (error: Error, context: Record<string, any> = {}) => {
      monitoring.log("error", error.message, {
        ...context,
        stack: error.stack,
        userId: user?.id,
      });
    },
    [user, monitoring]
  );

  return {
    logEvent,
    logError,
  };
};
